import axios from "axios";

export const getApartment = async (apartmentId) => {
    const url = `/api/v1/user_profile/apartments/${apartmentId}`;
    const res = await axios.get(url);
    return res.data;
};

export const createApartment = async (homeId, data) =>  {
    const url = `/api/v1/user_profile/homes/${homeId}/apartments`;
    const res = await axios.post(url, data);
    return res.data;
}

export const updateApartment = async (apartmentId, data) => {
    const url = `/api/v1/user_profile/apartments/${apartmentId}`;
    const res = await axios.patch(url, data);
    return res.data;
}

export const createApartmentPhoto = async (apartmentId, formData) => {
    const url = `/api/v1/user_profile/apartments/${apartmentId}/apartment_photos`;
    const config = {headers: { "Content-Type": "multipart/form-data" }}

    const res = await axios.post(url, formData, config);
    return res.data;
}
export const updateApartmentPhoto = async (photoId, data) => {
    const url = `/api/v1/user_profile/apartment_photos/${photoId}`;

    const res = await axios.patch(url, data);
    return res.data;
}


export const deleteApartmentPhoto = async (photoId) => {
    const url = `/api/v1/user_profile/apartment_photos/${photoId}`;
    const res = await axios.delete(url);
    return res.data;
}

export const updateApartmentServiceJoins = async (apartmentId, data) => {
    const url = `/api/v1/user_profile/apartments/${apartmentId}/apartment_service_joins`;
    const res = await axios.post(url, data);
    return res.data;
}

export const updateApartmentIcon = async (apartmentId, formData) => {
    const url = `/api/v1/user_profile/apartments/${apartmentId}`
    const config = {headers: { "Content-Type": "multipart/form-data" }}
    const res = await axios.patch(url, formData, config);
    return res.data;
}

// All available apartment services
export const getAllApartmentServices = async () => {
    const url = `/api/v1/user_profile/apartment_services`;
    const res = await axios.get(url);
    return res.data;
}

// All available apartment categories
export const getAllApartmentCategories = async () => {
    const url = `/api/v1/user_profile/apartment_categories`;
    const res = await axios.get(url);
    return res.data;
}

// All available apartment typologies
export const getAllApartmentTypologies = async () => {
    const url = `/api/v1/user_profile/apartment_typologies`;
    const res = await axios.get(url);
    return res.data;
}

// Archive an apartment
export const archiveApartment = async (apartmentId) => {
    const url = `/api/v1/user_profile/apartments/${apartmentId}/archive`;
    const res = await axios.post(url);
    return res.data;
}